import { interpolate } from "d3-interpolate";
import { Arc, PieArcDatum } from "d3-shape";

export function arcInterpolator<T>(
    newValue: PieArcDatum<T>,
    oldValue: PieArcDatum<T>
) {
    var i = interpolate(oldValue || newValue, newValue);
    return function (arcFn: Arc<any, PieArcDatum<T>>, t: number) {
        return arcFn(i(t));
    };
}
